export default __webpack_public_path__ + "static/media/BLR11.29d41899.jpg";